(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["text-with-video"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('katamu-video-text')) {
    class KatamuVideoText extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('.kvt__video');
        if (!this.video) return;

        this.frame = this.querySelector('.kvt__frame');
        this.toggleBtn = this.querySelector('.kvt__toggle');
        this.muteBtn = this.querySelector('.kvt__mute');
        this.userPaused = false;
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        this.video.muted = false;
        this.syncMute();

        this.onToggle = this.toggle.bind(this);
        this.onMute = this.toggleMute.bind(this);
        this.onPlay = this.handlePlay.bind(this);
        this.onPause = this.handlePause.bind(this);
        this.onEnded = this.handleEnded.bind(this);

        this.toggleBtn.addEventListener('click', this.onToggle);
        this.muteBtn.addEventListener('click', this.onMute);
        this.video.addEventListener('play', this.onPlay);
        this.video.addEventListener('pause', this.onPause);
        this.video.addEventListener('ended', this.onEnded);

        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                this.autoplay();
              } else if (!this.video.paused) {
                this.video.pause(); /* scrolled away, not a user pause */
              }
            });
          },
          { threshold: 0.5 }
        );
        this.observer.observe(this.frame);

        if (this.reducedMotion) this.showPlay(true);
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        if (!this.video) return;
        this.toggleBtn.removeEventListener('click', this.onToggle);
        this.muteBtn.removeEventListener('click', this.onMute);
        this.video.removeEventListener('play', this.onPlay);
        this.video.removeEventListener('pause', this.onPause);
        this.video.removeEventListener('ended', this.onEnded);
      }

      autoplay() {
        if (this.reducedMotion || this.userPaused || this.video.ended) return;
        this.play();
      }

      play() {
        if (this.video.ended) this.video.currentTime = 0;
        const attempt = this.video.play();
        if (attempt && typeof attempt.catch === 'function') {
          attempt.catch((err) => {
            if (err && err.name === 'AbortError') return; /* interrupted by a pause, ignore */
            if (err && err.name === 'NotAllowedError' && !this.video.muted) {
              /* Browser blocked autoplay with sound: fall back to muted autoplay */
              this.video.muted = true;
              this.syncMute();
              this.video.play().catch(() => this.showPlay(true));
              return;
            }
            this.showPlay(true);
          });
        }
      }

      toggle() {
        if (this.video.paused || this.video.ended) {
          this.userPaused = false;
          this.play();
        } else {
          this.userPaused = true;
          this.video.pause();
        }
      }

      toggleMute() {
        this.video.muted = !this.video.muted;
        const muted = this.video.muted;
        this.frame.classList.toggle('is-muted', muted);
        
        this.muteBtn.setAttribute('aria-label', muted ? 'Unmute video' : 'Mute video');
      }

      syncMute() {
        const muted = this.video.muted;
        this.frame.classList.toggle('is-muted', muted);
        this.muteBtn.setAttribute('aria-label', muted ? 'Unmute video' : 'Mute video');
      }

      handlePlay() {
        this.showPlay(false);
        this.toggleBtn.setAttribute('aria-label', 'Pause video');
      }

      handlePause() {
        if (this.video.ended) return;
        this.toggleBtn.setAttribute('aria-label', 'Play video');
        if (this.userPaused) this.showPlay(true);
      }

      handleEnded() {
        this.showPlay(true);
        this.toggleBtn.setAttribute('aria-label', 'Replay video');
      }

      showPlay(visible) {
        this.frame.classList.toggle('show-play', visible);
      }
    }

    customElements.define('katamu-video-text', KatamuVideoText);
  }

  } catch(e) { console.error(e); }
})();
})();
